import React from 'react';

/**
 * Reusable QR Code Generator component
 * Generates high-resolution QR code images from string values
 */
const QRCodeGenerator = ({ value, size = 120, caption, className = "" }) => {
  if (!value) return null;
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}`;

  return (
    <div className={`qr-code-wrapper ${className}`} style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
      <img
        src={qrUrl}
        alt={`QR Code for ${value}`}
        style={{ width: `${size}px`, height: `${size}px`, objectFit: 'contain' }}
        loading="lazy"
      />
      {caption && (
        <span className="qr-caption" style={{ fontSize: '8px', fontWeight: '700', color: '#64748b', marginTop: '2px', fontFamily: 'monospace' }}>
          {caption}
        </span>
      )}
    </div>
  );
};

export default QRCodeGenerator;
